import React, { useState } from 'react';
import { useForm } from '../hooks/useForm';
import { Global } from '../helpers/Global';
import useAuth from '../hooks/useAuth';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faLock } from '@fortawesome/free-solid-svg-icons';
import { Link, useNavigate } from 'react-router-dom';
import { ModalEULA } from './modalEULA'; // Importar el nuevo componente


export const LoginDNI = () => {
  const { formulario, cambiado } = useForm();
  const [logeado, setLogeado] = useState("no_logeado");
  const { setAuth } = useAuth();
  const navigate = useNavigate();
  const [usuarioPendienteEULA, setUsuarioPendienteEULA] = useState(null);

  const logUser = async (e) => {
    e.preventDefault();
    try {
      const request = await fetch(Global.url + 'usuarios/login-dni', {
        method: "POST",
        body: JSON.stringify(formulario), // { dni, password }
        headers: { "Content-Type": "application/json" }
      });
      const data = await request.json();

      if (request.ok) {
        // Si falta EULA, guardamos token provisional
        if (!data.user.eula_aceptado) {
          localStorage.setItem("token", data.token);
          setUsuarioPendienteEULA(data.user);
          return;
        }
        // Flujo normal
        localStorage.setItem("token", data.token);
        localStorage.setItem("user", JSON.stringify(data.user));
        setLogeado("logeado");
        setTimeout(() => {
          setAuth(data.user);
          navigate('/app/inicio', { replace: true });
        }, 600);
      } else {
        setLogeado("error");
      }
    } catch (err) {
      console.error("Error al iniciar sesión (DNI):", err);
      setLogeado("error");
    }
  };

  const aceptarEULA = async () => {
    try {
      const request = await fetch(Global.url + "usuarios/eula", {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`
        }
      });

      if (!request.ok) throw new Error("Error al aceptar el EULA");

      const updatedUser = { ...usuarioPendienteEULA, eula_aceptado: true };
      localStorage.setItem("user", JSON.stringify(updatedUser));
      setAuth(updatedUser);
      navigate('/app/inicio', { replace: true });
    } catch (error) {
      console.error("Error al aceptar EULA:", error);
      localStorage.clear();
      setUsuarioPendienteEULA(null);
      setLogeado("error");
    }
  };

  const rechazarEULA = () => {
    localStorage.clear();
    setUsuarioPendienteEULA(null);
    setLogeado("no_logeado");
  };

  return (
    <div className="layout_identificarse">
      <div>
        <h2>Iniciar sesión</h2>
        {logeado === "logeado" && <strong className="success-message">Usuario identificado correctamente</strong>}
        {logeado === "error" && <strong className="error-message">Error en la identificación</strong>}
      </div>

      <div className="content-form">
        <form className="form-login" onSubmit={logUser}>
          <div className="form-group">
            <FontAwesomeIcon className="icon-login" icon={faUser} />
            <input
              className="input-layout"
              type="text"
              name="dni"
              placeholder="DNI"
              onChange={cambiado}
            />
          </div>

          <div className="form-group">
            <FontAwesomeIcon className="icon-login" icon={faLock} />
            <input
              className="input-layout"
              type="password"
              name="password"
              placeholder="Contraseña"
              onChange={cambiado}
            />
          </div>

          <div>
            <input type="submit" value="Identifícate" className="btn btn-login" />
            <div className="enlace-reset" style={{ marginTop: "10px", textAlign: "center" }}>
              <Link to="/olvide-password">¿Has olvidado tu contraseña?</Link>
            </div>
          </div>
        </form>
      </div>

      {usuarioPendienteEULA && (
        <ModalEULA onAccept={aceptarEULA} onReject={rechazarEULA} />
      )}
    </div>
  );
};

